import { Enums } from '@bode-canada/core';
import ServerlessApiService from '../ServerlessApiService';

const { ServerlessApiPathEnum, SearchApiPathEnum } = Enums;

export default class SearchApiService {
  static BASE_URL = `/${SearchApiPathEnum.SEARCH}/${ServerlessApiPathEnum.V1}`;

  static searchActiveListings(body) {
    return ServerlessApiService.post(
      `${this.BASE_URL}/${SearchApiPathEnum.LISTINGS}`,
      body,
    );
  }

  static searchSoldListings(body) {
    return ServerlessApiService.post(
      `${this.BASE_URL}/${SearchApiPathEnum.LISTINGS}/${SearchApiPathEnum.SOLD}`,
      body,
    );
  }
}
